import { Formik } from 'formik';
import { isEmpty } from 'lodash';
import React from 'react';
import Form, { FormElement } from '@dashboard/components/Form';
import FormSubmit from '@dashboard/components/Formik/components/FormSubmit';
import { Select } from '@dashboard/components/Formik';
import FormError from '@dashboard/components/Formik/components/FormError';
import locales from '@dashboard/services/countries/locales';
import { transformApiErrorToFormik } from '@dashboard/services/form';
import { formatPrice } from '@dashboard/services/formatting';
import usePage from '@dashboard/hooks/usePage';
import { PAGE_TYPES } from '@dashboard/enums/page-types';

const LocaleForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Formik
      initialValues={{
        locale: page.locale,
      }}
      onSubmit={async (values, actions) => {
        actions.setStatus(undefined);

        const { data, error } = await updatePage.mutateAsync(values);

        if (data) {
          actions.setStatus('');
          actions.resetForm({
            values: {
              locale: data.locale,
            },
          });
        } else {
          const { status, errors } = transformApiErrorToFormik(error);

          if (!isEmpty(errors)) {
            actions.setErrors(errors);
          } else {
            actions.setStatus(status);
          }
        }
      }}
    >
      {({ status, dirty, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <FormElement>
            <Select name="locale" id="locale">
              {locales.map(country => (
                <option key={country.code} value={country.code}>
                  {page.type === PAGE_TYPES.CHECKOUT && (
                    <>
                      {country.country}:{' '}
                      {formatPrice({
                        locale: country.code,
                        currency: page.product.currency,
                        amount: page.product.price,
                      })}
                    </>
                  )}
                  {page.type === PAGE_TYPES.EVENT && (
                    <>
                      {country.country}:{' '}
                      {formatPrice({
                        locale: country.code,
                        currency: page.eventDetails.currency,
                        amount: 1000,
                      })}
                    </>
                  )}

                  {page.type === PAGE_TYPES.FORM && <>{country.country}</>}
                </option>
              ))}
            </Select>
            <FormError name="locale" />
          </FormElement>

          <FormElement>{status && status}</FormElement>

          <FormSubmit>
            <FormSubmit.Button>Save</FormSubmit.Button>
            <FormSubmit.State visible={!!dirty} />
          </FormSubmit>
        </Form>
      )}
    </Formik>
  );
};

export default LocaleForm;
